<template>
  <div class="warpper padding-sm">
    <div class="flex align-center justify-between margin-bottom-sm list-title">
      <b>子账号管理</b>
      <span class="add-btn" @click="addItem(false)"
      >添加
            </span>
    </div>
    <div class="ship-list">
      <el-table :data="lists" header-row-class-name="table-header"
                border
                style="width: 100%; border-radius: 10px">
        <el-table-column label="姓名" prop="name">
          <template slot-scope="scope">
            <div class="flex justify-center"> {{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="账号" prop="phone">
          <template slot-scope="scope">
            <div class="flex justify-center">{{ scope.row.account }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="flex justify-center">
              <el-button @click="addItem(scope.row)" type="text">编辑</el-button>
              <span class="padding-lr-sm"></span>
              <el-button @click="itemPower(scope.row.id)" type="text">权限</el-button>
              <span class="padding-lr-sm"></span>
              <el-button style="color: red" @click="deleteItem(scope.row.id)" type="text">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-admin-dialog :applyDialogVisible="applyDialogVisible" :id="cur_id" :info="cur_item"
                      @watchState="watchState"></add-admin-dialog>
  </div>
</template>

<script>
import {getSonAdmin, delSonAdmin} from '@/api/branch'
import AddAdminDialog from "@/components/AddFhAdminDialog.vue";

export default {
  name: "serverList",
  data() {
    return {
      searchName: '',
      lists: [],
      cur_item: null,
      cur_id: 0,
      applyDialogVisible: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {
    this.$emit('setIndex', [5, 5], '子账号管理')
    this.init()
  },
  components: {AddAdminDialog},
  methods: {
    //  页面加载时请求
    async init() {
      let _data = await getSonAdmin(this.searchName)
      if (_data.status === 200) {
        this.lists = _data.data
        this.total = _data.count
      } else {
        this.lists = []
      }
    },
    addItem(data) {
      this.applyDialogVisible = true
      if (data) {
        this.cur_item = JSON.parse(JSON.stringify(data))
        this.cur_id = data.id
      } else {
        this.cur_item = null
        this.cur_id = 0
      }
    },
    itemPower(id) {
      this.$router.push('/branch/members/sonPower/' + id)
    },
    deleteItem(id) {
      this.$confirm("确定要删除该账号吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.delSonAdmin(id)
      })
    },
    async delSonAdmin(id) {
      let _data = await delSonAdmin(id)
      if (_data.status === 200) {
        this.init()
        this.$message.success(_data.msg)
      }
    },
    watchState(state) {
      if (state) this.init()
      this.applyDialogVisible = false;
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.warpper {
  background: #fff;
  border-radius: 10px;

  .list-title {
    b {
      font-size: 26px;
      line-height: 34px;
    }

    .add-btn {
      display: block;
      width: 200px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
      linear-gradient(#0a2240, #0a2240);
      background-blend-mode: normal, normal;
      border-radius: 20px;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
